<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="姓名："
        prop="name">
        <el-input
          v-model="info.name"
          show-word-limit
          :maxlength="12"></el-input>
      </el-form-item>
      <el-form-item
        label="手机号："
        prop="mobilePhone">
        <el-input
          v-model="info.mobilePhone"
          show-word-limit
          :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item
        label="微信手机号："
        prop="wxMobilePhone">
        <el-input
          v-model="info.wxMobilePhone"
          show-word-limit
          :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item
        label="固定电话："
        prop="phone">
        <el-input
          v-model="info.phone"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item
        label="邮箱："
        prop="email">
        <el-input
          v-model="info.email"
          show-word-limit
          :maxlength="50"></el-input>
      </el-form-item>
      <el-form-item
        label="部门："
        prop="department">
        <el-input
          v-model="info.department"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item
        label="职位："
        prop="position">
        <el-input
          v-model="info.position"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item
        label="公司名称："
        prop="corpName">
        <el-input
          v-model="info.corpName"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="公司地址："
        prop="corpAddress">
        <el-input
          v-model="info.corpAddress"
          show-word-limit
          :maxlength="50"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Common from '@/service/common'
export default {
  name: 'EditPackageModal',
  props: {
    callback: { type: Function }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: { nameCardId: null, name: '', mobilePhone: '', wxMobilePhone: '', email: '', department: '', position: '', phone: '', corpName: '', corpAddress: '' },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[0-9][0-9]\d{8}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^[0][0-9]{2,3}-[0-9]{5,10}$/, message: '请输入正确的固定电话', trigger: 'blur' }
        ],
        wxMobilePhone: [
          { required: true, message: '请输入微信手机号', trigger: 'blur' },
          { pattern: /^1[0-9][0-9]\d{8}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请输入职位', trigger: 'blur' }
        ],
        corpName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        corpAddress: [
          { required: true, message: '请输入公司地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title({ info }) {
      return (info.nameCardId ? '编辑' : '新增') + '电子名片'
    }
  },
  methods: {
    handleClosed() {
      this.info = { ...this.info, ...this.$options.data().info }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.nameCardId ? 'updatenamecard' : 'addnamecard'
          Common[dispatch]({ ...this.info })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.info = { ...this.info, ...options }
      this.visible = true
    }
  }
}
</script>
